import {
  BannerBadge,
  BannerBadgeType,
} from 'client/respondent/feed/components/body/feed-card/feed-card-banner';
import { RespondentFeedItemBadgeType } from 'client/shared/graphql-client/graphql-operations.g';
import { BalancingActSimulationType, QuestionSetType } from 'core';
import { QuestionSetFeatureSetType } from 'graphql-schema/schema-types.g';

export function convertBadgeType_GqlToClient(
  badge: RespondentFeedItemBadgeType
): BannerBadgeType {
  switch (badge) {
    case RespondentFeedItemBadgeType.BALANCING_ACT_SIMULATION:
      return BannerBadgeType.BALANCING_ACT_SIMULATION;
    case RespondentFeedItemBadgeType.POLL_SET:
      return BannerBadgeType.POLL_SET;
    case RespondentFeedItemBadgeType.SURVEY:
      return BannerBadgeType.SURVEY;
    case RespondentFeedItemBadgeType.CONTENT_POST:
      return BannerBadgeType.CONTENT_POST;
    case RespondentFeedItemBadgeType.ENGAGEMENT_PAGE:
      return BannerBadgeType.ENGAGEMENT_PAGE;
    case RespondentFeedItemBadgeType.REPOST:
      return BannerBadgeType.REPOST;
    case RespondentFeedItemBadgeType.QUESTION:
      return BannerBadgeType.QUESTION;
    case RespondentFeedItemBadgeType.POLCO_LIVE:
      return BannerBadgeType.POLCO_LIVE;
    case RespondentFeedItemBadgeType.IDEA:
      return BannerBadgeType.IDEA;
  }
}

export function setTypeToBadge(
  type: QuestionSetType | BalancingActSimulationType,
  featureSetType: QuestionSetFeatureSetType | null
): BannerBadge {
  switch (type) {
    case QuestionSetType.GENERIC:
      switch (featureSetType) {
        case QuestionSetFeatureSetType.CONTENT_POST:
        case null:
          return {
            type: BannerBadgeType.CONTENT_POST,
            label: 'Content Post',
          };
        case QuestionSetFeatureSetType.ENGAGEMENT_PAGE:
          return {
            type: BannerBadgeType.ENGAGEMENT_PAGE,
            label: 'Engagement Page',
          };
      }
    case QuestionSetType.POLCO_LIVE:
      return {
        type: BannerBadgeType.POLCO_LIVE,
        label: 'Live Event',
      };
    case QuestionSetType.SET:
      return {
        type: BannerBadgeType.POLL_SET,
        label: 'Poll',
      };
    case QuestionSetType.SURVEY:
      return {
        type: BannerBadgeType.SURVEY,
        label: 'Survey',
      };
    case BalancingActSimulationType.RECEIPT:
      return {
        type: BannerBadgeType.BALANCING_ACT_SIMULATION,
        label: 'Taxpayer Receipt',
      };
    case BalancingActSimulationType.HOUSING:
      return {
        type: BannerBadgeType.BALANCING_ACT_SIMULATION,
        label: 'Housing Simulation',
      };
    case BalancingActSimulationType.BUDGET:
      return {
        type: BannerBadgeType.BALANCING_ACT_SIMULATION,
        label: 'Budget Simulation',
      };
    case BalancingActSimulationType.CLIMATE:
    case BalancingActSimulationType.NON_NUMERICAL:
    case BalancingActSimulationType.POINTS:
    case BalancingActSimulationType.PROJECT_MANAGEMENT:
      return {
        type: BannerBadgeType.BALANCING_ACT_SIMULATION,
        label: 'Simulation',
      };
  }
}
